import { LocLink } from "~/components/locs/LocLink";
import { OurLoaderArgs } from "./Loaders";
import { pg } from "~/pg.server";
import { and, eq } from "drizzle-orm";
import { loadMarkdown } from "./Markdown.server";

export function getLocList(
  locs: {
    name: string;
    locName: string;
  }[]
) {
  return locs.map((loc, i) => (
    <span key={i}>
      <LocLink loc={loc} />
      {i < locs.length - 1 ? ", " : ""}
    </span>
  ));
}

export async function locMdPage(cx: OurLoaderArgs, locName: string) {
  const page = await pg.db
    .select({
      contentEn: pg.mdRevisions.contentEn,
      contentRu: pg.mdRevisions.contentRu,
    })
    .from(pg.mdPages)
    .where(
      and(eq(pg.mdPages.locName, locName), eq(pg.mdPages.isDeleted, false))
    )
    .innerJoin(pg.mdRevisions, eq(pg.mdPages.revisionId, pg.mdRevisions.id))
    .then((res) => res.at(0));

  return {
    content:
      page?.contentEn && cx.realm.lang === "en"
        ? await loadMarkdown(
            page?.contentEn,
            cx.gd.all_gd!,
            cx.realm.lang,
            cx.realm.game
          )
        : page?.contentRu &&
          (await loadMarkdown(
            page?.contentRu,
            cx.gd.all_gd!,
            cx.realm.lang,
            cx.realm.game
          )),
  };
}
